/**
 * Frontend tRPC Client
 *
 * Connects to the backend tRPC API server
 */

import { createTRPCReact } from '@trpc/react-query';
import type { AppRouter } from '../../../../../src/api/trpc/root.js';

/**
 * Typed tRPC client for React
 *
 * Usage:
 * ```tsx
 * import { trpc } from '@/lib/trpc/client';
 *
 * function MyComponent() {
 *   const { data, isLoading } = trpc.ai.list.useQuery({ page: 1, limit: 20 });
 *   const createMutation = trpc.ai.create.useMutation();
 *
 *   return <div>...</div>;
 * }
 * ```
 */
export const trpc = createTRPCReact<AppRouter>();
